import {
    MASTER_COMPANY_LIST,
    COMPANY_REQUEST_LIST,
    MASTER_COMPANY_LIST_ERROR,
    CLEAR_MASTER_COMPANY_ERROR,
    CACHE_MASTER_COMPANY_LIST,
    CLEAR_MASTER_COMPANY_CACHE,
    CACHE_COMPANY_REQUEST_LIST,
    CLEAR_COMPANY_REQUEST_CACHE,
} from "./constant";

export const initialState = {
    masterCompanyList: [],
    masterCompanyListError: null,

    // Master company cache
    masterCompanyCache: {},

    companyPagination: {
        totalRecord: 0,
        currentRecord: 0,
        currentPage: 1,
        nextPage: 0,
        totalPage: 1,
    },

    companyRequestList: [],
    companyRequestCache: {},

    companyRequestListPagination: {
        totalRecord: 0,
        currentRecord: 0,
        currentPage: 1,
        nextPage: 0,
        totalPage: 1,
    },
};

export default (state = initialState, action) => {
    switch (action.type) {
        // ==========================================
        // MASTER COMPANY LIST
        // ==========================================

        case MASTER_COMPANY_LIST:
            return {
                ...state,
                masterCompanyList: action.payload.data || [],
                companyPagination: action.payload.pagination || {},
                masterCompanyListError: null,
            };

        case MASTER_COMPANY_LIST_ERROR:
            return {
                ...state,
                masterCompanyListError:
                    action.payload || "Something went wrong",
            };

        case CLEAR_MASTER_COMPANY_ERROR:
            return {
                ...state,
                masterCompanyListError: null,
            };

        // ==========================================
        // MASTER COMPANY CACHE
        // ==========================================

        case CACHE_MASTER_COMPANY_LIST:
            return {
                ...state,

                masterCompanyCache: {
                    ...state.masterCompanyCache,

                    [action.payload.key]: {
                        response: action.payload.response,
                        timestamp: action.payload.timestamp,
                    },
                },
            };

        case CLEAR_MASTER_COMPANY_CACHE:
            return {
                ...state,
                masterCompanyCache: {},
            };

        // ==========================================
        // COMPANY REQUEST LIST
        // ==========================================

        case COMPANY_REQUEST_LIST:
            return {
                ...state,

                companyRequestList:
                    action.payload.data || [],

                companyRequestListPagination:
                    action.payload.pagination || {},
            };

        // ==========================================
        // COMPANY REQUEST CACHE
        // ==========================================

        case CACHE_COMPANY_REQUEST_LIST:
            return {
                ...state,

                companyRequestCache: {
                    ...state.companyRequestCache,

                    [action.payload.key]: {
                        response: action.payload.response,
                        timestamp: action.payload.timestamp,
                    },
                },
            };

        case CLEAR_COMPANY_REQUEST_CACHE:
            return {
                ...state,
                companyRequestCache: {},
            };

        default:
            return state;
    }
};